import useGetTaskGraphDetails from './useGetTaskGraphDetails';

export default useGetTaskGraphDetails;
export * from './useGetTaskGraphDetails';
